import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { authenticatedRoute } from "../_authenticated.js";

export const crmCampaignsRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/crm/campaigns",
  component: lazyRouteComponent(() => import("./crm-campaigns.page.js"), "CrmCampaignsPage"),
});
